const dayjs = require('dayjs');

module.exports = (endDate, startDate) => {
    return dayjs(endDate, 'YYYY-MM-DD').diff(startDate, 'month') + 1;
};
